<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" @click="$router.go(-1)" class="button">返回</button>
				<hr />
			</p>
			<p>
				图书信息: <span v-if="book!=null" class="red">
					{{ book.BooksName +' '+ book.WriterName +' '+ book.WriterBooksReferences }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					书籍编号:{{book.BooksNumCode}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					书籍分类:{{book.Classification1 }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					书籍归属:{{book.BelongTo}}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div style="padding-top: 1rem;">
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>借出人</th>
							<th>借出编号</th>
							<th>借出位置</th>
							<th>借出时间</th>
							<th>还入编号</th>
							<th>还入位置</th>
							<th>还入时间</th>
							<th>还书备注</th>
							<th>是否归还</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index) in history">
							<td>{{index+1}}</td>
							<td class="left">
								{{i.CustomerName}}<br />
								{{i.CustomerPhone}}
							</td>
							<td>
								{{i.BooksNumCode}}
							</td>
							<td class="left">
								{{i.ShopName}}<br />
								{{i.BorrowOutPlace}}
							</td>
							<td>
								{{i.BorrowDate}}
							</td>
							<td>
								{{i.ReturnBooksNumCode}}
							</td>
							<td class="left">
								{{i.ReturnShopName}}<br />
								{{i.ReturnPlace}}
							</td>
							<td>
								{{i.ReturnDate}}
							</td>
							<td>
								{{i.Remarks}}
							</td>
							<td>
								{{i.IsReturn}}
							</td>
						</tr>

					</tbody>
				</table>

			</div>
			
		</div>
<div class="foot_pages">
				<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
				<span>{{page}}</span>

				<select v-model="pageRows" @change="changePageRows">
					<option value="10">10/页</option>
					<option value="15">15/页</option>
					<option value="20">20/页</option>
					<option value="25">25/页</option>
					<option value="30">30/页</option>

				</select>
				<button class="button" :class="{'disabled':down}" :disabled="down"
					@click="changePages('down')">下一页</button>
			</div>
	</div>





</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
